import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import { useVouchers } from "../../data/useVouchers";
import { IVoucher } from "../../models/Voucher";
import VoucherTable from "../../components/vouchers/VoucherTable";
import VoucherModal from "../../components/vouchers/VoucherModal";

export default function Vouchers() {
    const { setInfo } = usePageNameContext();
    const { vouchers: allVouchers, create } = useVouchers();
    const [vouchers, setVouchers] = useState<IVoucher[] | undefined>(undefined);
    const [voucher, setVoucher] = useState<IVoucher | undefined>(undefined);

    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [createOpen, setCreateOpen] = useState(false);

    useEffect(() => {
        setInfo({
            name: "Vouchers",
            desc: "Manage vouchers",
        });
    }, []);

    useEffect(() => {
        if (!allVouchers.isLoading && allVouchers.data) {
            // Filtering code goes here
            setVouchers(allVouchers.data?.data);
            setIsLoading(false);
        }
    }, [allVouchers.isLoading, allVouchers.data, searchTerm]);

    const handleSetVoucher = (voucher: IVoucher) => {
        setVoucher(voucher);
        setCreateOpen(true);
    }

    const handleAddVoucher = () => {
        setCreateOpen(true);
    }

    if (allVouchers.isLoading || isLoading) {
        return (
            <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
                <LoadingWheel />
            </div>
        );
    }

    return (
        <>
            <VoucherModal open={createOpen} setOpen={setCreateOpen} voucher={voucher} />
            <div className="mt-4 flex justify-between">
                <button
                    className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                    onClick={handleAddVoucher}
                >
                    <PlusSmallIcon className="h-5 w-5 mr-2" />
                    Add Voucher
                </button>
            </div>
            <VoucherTable vouchers={vouchers ?? []} setVoucher={handleSetVoucher} />
        </>
    );
}